import { ReactNode } from "react";

interface ActionModalHeaderProps {
  icon: string;
  tone?: "blue" | "ok" | "warn" | "bad";
  title: string;
  subtitle?: ReactNode;
  onClose: () => void;
}

// Icon tile + title + subtitle, used at the top of every customer action modal
const ActionModalHeader = ({ icon, tone = "blue", title, subtitle, onClose }: ActionModalHeaderProps) => (
  <div style={{ display: "flex", gap: 12, alignItems: "flex-start", padding: "18px 20px 4px" }}>
    <div className={`cx-ic ${tone}`} style={{ width: 34, height: 34, fontSize: 16, borderRadius: 10 }}><i className={icon}></i></div>
    <div style={{ minWidth: 0, flex: 1 }}>
      <div style={{ fontSize: 15, fontWeight: 600 }}>{title}</div>
      {subtitle && <div className="fs12 muted">{subtitle}</div>}
    </div>
    <button type="button" onClick={onClose} aria-label="Close" style={{ fontSize: 20, color: "#6B7280" }}><i className="ri-close-line"></i></button>
  </div>
);

// Note shown in static (design-only) modals
export const DemoNote = () => (
  <p className="cx-help" style={{ marginTop: 12 }}><i className="ri-information-line"></i> Demo only — this action is not connected to the backend yet, nothing is saved.</p>
);

export const customerName = (u: any) =>
  u ? (u.user_companyName || `${u.user_first_name || ""} ${u.user_last_name || ""}`.trim() || u.user_email) : "";

export default ActionModalHeader;
